<template>
  <el-radio-group v-model="currentValue" size="mini" class="language-radio-buttons">
    <el-radio-button v-for="opt in langOptions" :key="opt.value" :label="opt.value">
      {{ opt.label }}
    </el-radio-button>
  </el-radio-group>
</template>

<script>
import config from '@/config'

export default {
  name: 'LanguageRadioButtons',
  data() {
    return {
      langOptions: Array.isArray(config.languages) ? config.languages : [],
    }
  },
  props: {
    value: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    currentValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.language-radio-buttons {
  display: inline-flex;
}
</style>
